import createSvgIcon from '../Utils/CreateSvgIcon';

export const TickCircle = createSvgIcon(
  <>
    <circle
      cx="12"
      cy="12"
      fill="currentColor"
      fillOpacity="0.12"
      r="10"
      transform="rotate(90 12 12)"
    />
    <circle cx="12" cy="12" fill="currentColor" r="10" />
    <path d="m6.5 11.5 3.667 3.5L17.5 8" fill="none" stroke="#fff" strokeWidth="2" />
  </>,
  'TickCircle',
);
